import * as React from 'react'

function SvgRepairKitChecked(props) {
  return (
    <svg
      width={40}
      height={40}
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      {...props}
    >
      <path d="m32.293 8.293 1.414 1.414L28 15.414l-3.707-3.707 1.414-1.414L28 12.586l4.293-4.293Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 3a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-6 8a6 6 0 1 0 12 0 6 6 0 0 0-12 0Z"
      />
      <path d="M19.125 13.338c.15-.916.443-1.685.875-2.309a8.972 8.972 0 0 0 .706 3.471h-.594l-.987-1.162ZM20.164 16h1.352a9.052 9.052 0 0 0 1.827 2h-1.84c.133.292.278.512.419.682.294.357.612.558.958.771l.03.019c.152.093.375.23.556.392.218.195.477.513.526.984.025.239-.029.438-.081.569l-.553 1.382A5 5 0 0 0 23 24.656v2.726c0 .252.059.5.17.724l.054.106a1.427 1.427 0 0 0 2.552 0l.053-.106c.113-.225.171-.472.171-.724V21c0-.51.254-.877.537-1.11.076-.062.159-.117.24-.167a9.018 9.018 0 0 0 3.005.243c-.602.802-1.3 1.14-1.725 1.344l-.057.028v6.044c0 .562-.13 1.116-.382 1.618l-.053.106a3.427 3.427 0 0 1-6.13 0L21.382 29A3.618 3.618 0 0 1 21 27.382v-2.727a7 7 0 0 1 .5-2.6l.355-.884-.04-.025c-.358-.22-.922-.566-1.437-1.192-.53-.643-.966-1.523-1.197-2.772L20.164 16Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.83 9h2.34l.35 4.196-.52 1.04V17h1.588a1.22 1.22 0 0 1 1.016 1.897c-.3.45-.36 1.02-.159 1.523l.197.493A5 5 0 0 1 17 22.77v4.612A3.618 3.618 0 0 1 13.382 31h-.764A3.618 3.618 0 0 1 9 27.382V22.77a5 5 0 0 1 .358-1.857l.197-.493a1.644 1.644 0 0 0-.159-1.523A1.22 1.22 0 0 1 10.412 17H12v-2.764l-.52-1.04L11.83 9Zm-.248 10a3.644 3.644 0 0 1-.17 2.163l-.197.493A2.999 2.999 0 0 0 11 22.77v4.612A1.619 1.619 0 0 0 12.618 29h.764A1.618 1.618 0 0 0 15 27.382V22.77c0-.381-.073-.76-.215-1.114l-.197-.493a3.644 3.644 0 0 1-.17-2.163h-2.836Z"
      />
    </svg>
  )
}

export default SvgRepairKitChecked
